<template>
  <div :class="jel_getClassObject(content)">
    <Menu :content="contentMenu" @click.native="estOuvert = !estOuvert">
      <template #element="{ itemElement }">
        <div
          v-show="estOuvert"
          class="d-md-flex mx-2 overflow-hidden"
          :class="[itemElement.image ? 'p-0' : 'justify-content-between']"
        >
          <b-img-lazy
            v-if="itemElement.image"
            class="img-item"
            :src="jel_getFichierSrc(itemElement.image)"
            :alt="itemElement.item"
          />
          <div class="d-flex align-items-center">
            <p class="texte-element overflow-hidden pb-0">{{ itemElement.item }}</p>
          </div>
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import Menu from '@/components/base/Menu';

export default {
  name: 'MenuPiedDePage',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Menu },
  props: { content: { type: Object, required: true } },
  data() {
    return { estOuvert: false };
  },
  computed: {
    contentMenu() {
      return {
        titre: this.content.titre,
        listeItems: this.content.listeItems,
        menuPiedDePage: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
div::v-deep div.list-group {
  border-bottom: 1px solid #dee2e6;
  display: flex;
  cursor: pointer;
  .list-group-item {
    font-family: graphik_regular;
    padding: 0;
    > div {
      display: flex;

      font-size: 0.9375rem;
      line-height: 1.125rem;
      padding: 1rem;
    }
    .bouton-fleche {
      display: none;
    }
    &.liste-titre {
      font-size: 1rem;
      line-height: 1.25rem;
      font-family: graphik_medium;
    }
    svg {
      color: $couleur-primaire-bouton-theme-clair;
      margin-right: 0.8rem;
      margin-top: 0.25rem;
      height: 0.8rem;
      width: 0.8rem;
    }
    .img-item {
      height: 55px;
      width: 55px;
      object-fit: contain;
    }
    &:focus-visible {
      outline: none;
      background-color: $bleu-pale-casino;
    }
  }
  @include media-breakpoint-up(md) {
    border-bottom: none;
    cursor: unset;
    .list-group-item {
      > div {
        border: none;
      }
    }
  }
}
.texte-element {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
